import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-res-sales-dashboard',
    templateUrl: './res-sales-dashboard.component.html',
    styleUrls: ['./res-sales-dashboard.component.css'],
    standalone: false
})
export class ResSalesDashboardComponent implements OnInit {

	@Input() showSearchUI = true;
	resRevByDay: any = [];
	holdReservations: any = [];
	holdReservationsCount: any = 0;
	groupDefaultExpanded: any;
	requestCount: any = 0;
	resRevByDayForDetailsSearch: any = [];
	resRevTotal: any = [];
	revenueTtl: any = 0;
	revenuePNTAvg: any = 0;
	resRevMaster: any = [];
	dateValue: Date = new Date();
	reportName = 'RES_SALES_DASHBOARD'

	guestReservations: any[] = [];     // OP, NA, OO, OG
	cancelledReservations: any[] = []; // OX
	holdRevMasReservations: any[] = [];      // QH
	expiredReservations: any[] = [];   // QE

	upsellOffers: any[] = [];
	upsellLoading = false;

	readonly GUEST_STATUSES = ['OP', 'NA', 'OO', 'OG'];
	readonly CANCELLED_STATUSES = ['OX'];
	readonly HOLD_STATUSES = ['QH'];
	readonly EXPIRED_STATUSES = ['QE'];

	constructor(
		public messageService: MessageService,
		public reportService: ReportService) { }


	// forms
	formLoading = false;
	resRevByDayLoading = false;
	columnApi: ColumnApi;

	// to hold the current search
	currentSearchForm: any;

	ngOnInit(): void {

	}

	onSearchSubmit(searchForm: any) {
		this.currentSearchForm = searchForm;
		this.formLoading = true;
		searchForm.reportName = this.reportName;
		if (!searchForm.filterDateStart && !searchForm.cancelDateEnd) {
			if (searchForm.resTypes == null || searchForm.resTypes.length === 0) {
				searchForm.reservationStatusList = this.reportService.revanueReservations;
			}
		}
		searchForm.saleDateStart = this.addLocalTimeToDateTime(new Date(searchForm.saleDateStart));
		searchForm.saleDateEnd = this.addLocalTimeToDateTime(new Date(searchForm.saleDateEnd));
		// Call new endpoint first — populates KPI cards + property tables
		this.runSalesByPropertyReport(searchForm);
	}

	runSalesByPropertyReport(searchForm: any) {
		this.reportService.salesByPropertyReport(searchForm)
			.subscribe(
				res => {
					console.log('runSalesByPropertyReport SUCCESS: records =', res.data?.resRevenues?.resRevMaster?.length ?? 0);
					this.resRevMaster = res.data.resRevenues?.resRevMaster ?? [];
					this.resRevTotal = res.data.resRevenues?.resRevTotal;
					const resType = (searchForm.resTypes == null || searchForm.resTypes.length === 0)
						? this.reportService.revanueReservations
						: searchForm.resTypes;
					const totals = this.resRevMaster.reduce(
						(acc, item) => {
							// Revenue: use net Owner+KBM fee (products 105+106, ex-tax) to match
							// the Analytics dashboard formula. Composite properties (listingType=2)
							// are already excluded by the backend DELETE, but guard here for safety.
							const isNotComposite = item.listingType != null ? item.listingType !== 2 : true;
							if ((item.resStatus === 'OP' || item.resStatus === 'OG') && isNotComposite && (item.revOwnerKBMPNT || 0) > 0) {
								acc.revenueTtl += item.revOwnerKBMTTL || 0;
								acc.revenuePNTTtl += item.revOwnerKBMPNT || 0;
								acc.count++;
							}
							return acc;
						},
						{ revenueTtl: 0, revenuePNTTtl: 0, count: 0 }
					);
					this.revenueTtl = totals.revenueTtl;
					this.revenuePNTAvg = totals.count > 0 ? totals.revenuePNTTtl / totals.count : 0;
					this.splitReservations();
					this.requestCount = this.requestCount + 1;
					this.groupDefaultExpanded = 0;
					this.columnApi?.autoSizeAllColumns();
					this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Report loaded successfully', life: 3000 });
					// Now call old endpoint for resRevByDay tables — spinner shown only on that section
					this.runReservationRevenueReport(searchForm);
					// Load upsell pipeline table (independent — runs in parallel)
					this.runPromotionOfferDashboard(searchForm);
				},
				err => {
					console.log('runSalesByPropertyReport FAIL: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
				},
				() => { this.formLoading = false; });
	}

	runReservationRevenueReport(searchForm: any) {
		try {
			this.resRevByDayLoading = true;
			this.reportService.reservationRevenueReport(searchForm)
				.subscribe(
					res => {
						console.log('runReservationRevenueReport SUCCESS');
						this.holdReservations = res.data.resRevenues?.holdReservations;
						if (this.holdReservations != undefined && this.holdReservations != null) {
							this.holdReservationsCount = this.holdReservations.length;
						}
						this.resRevByDay = res.data.resRevenues.resRevByDay;
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.resRevByDayLoading = false; });
		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

	runPromotionOfferDashboard(searchForm: any) {
		this.upsellLoading = true;
		this.reportService.promotionOfferDashboard(searchForm)
			.subscribe(
				res => {
					console.log('runPromotionOfferDashboard SUCCESS: offers =', res.data?.promotionOffers?.length ?? 0);
					this.upsellOffers = res.data?.promotionOffers ?? [];
				},
				err => {
					console.log('runPromotionOfferDashboard FAIL: ' + JSON.stringify(err));
					this.upsellOffers = [];
				},
				() => { this.upsellLoading = false; });
	}

	private splitReservations(): void {
		if (!this.resRevMaster || this.resRevMaster.length === 0) {
			this.guestReservations = [];
			this.cancelledReservations = [];
			this.holdReservations = [];
			this.expiredReservations = [];
			return;
		}

		this.guestReservations = this.resRevMaster.filter(r =>
			this.GUEST_STATUSES.includes(r.resStatus)
		);
		const toMidnight = (d: Date) =>
			new Date(d.getFullYear(), d.getMonth(), d.getDate());
		const startDate = this.currentSearchForm.filterDateStart
				? toMidnight(new Date(this.currentSearchForm.filterDateStart))
				: null;
			const endDate = this.currentSearchForm.filterDateEnd
				? toMidnight(new Date(this.currentSearchForm.filterDateEnd))
				: null;
		this.cancelledReservations = this.resRevMaster.filter(r => {
			if (!r.cancelDate) return false;

			const cancelDate = toMidnight(new Date(r.cancelDate));

			// check if cancelDate falls in range
			const inRange =
				(!startDate || cancelDate >= startDate) &&
				(!endDate || cancelDate <= endDate);

			// final condition
			return this.CANCELLED_STATUSES.includes(r.resStatus) && inRange;
		});

		this.holdReservations = this.resRevMaster.filter(r => {
			if (!r.holdDate) return false;

			const holdDate = toMidnight(new Date(r.holdDate));

			// check if holdDate falls in range
			const inRange =
				(!startDate || holdDate >= startDate) &&
				(!endDate || holdDate <= endDate);

			// final condition
			return this.HOLD_STATUSES.includes(r.resStatus) && inRange
		}
		);

		this.expiredReservations = this.resRevMaster.filter(r => 
			this.EXPIRED_STATUSES.includes(r.resStatus)
		);
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime 
	 * @returns 
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

	ngAfterViewInit(): void {
	}

}
